<template>
    <GDialog
        v-model="modalStore.updateAppModal.show"
        max-width="500"
        border-radius="10"
        :persistent="true"
    >
        <div class="update-app-modal">
            <div class="container">
                <div class="modal-header text-center">
                    <h2 class="text-h2 text-bold">Потрібне оновлення</h2>
                </div>

                <div class="modal-body text-center">
                    <p class="text-h4">
                        Ваша версія додатка застаріла. Будь ласка, оновіть додаток для продовження
                        роботи.
                    </p>
                </div>

                <div class="modal-buttons">
                    <a
                        :href="modalStore.updateAppModal.downloadUrl"
                        target="_blank"
                        class="download-link"
                    >
                        <ButtonComponent btn-style="gradient" text="Завантажити оновлення" />
                    </a>
                </div>
            </div>
        </div>
    </GDialog>
</template>

<script>
import ButtonComponent from '@/components/ButtonComponent.vue'
import { useModalStore } from '@/stores/index.js'

export default {
    name: 'UpdateAppModal',
    components: { ButtonComponent },
    setup() {
        const modalStore = useModalStore()

        return { modalStore }
    }
}
</script>

<style scoped lang="scss">
.update-app-modal {
    padding: 2rem 1rem;

    .modal-header {
        margin-bottom: 1.5rem;
    }

    .modal-body {
        margin-bottom: 2rem;
    }

    .download-link {
        text-decoration: none;
        display: block;
        width: 100%;
    }

    .button-component {
        width: 100% !important;
    }
}
</style>
